import { CheckCircleOutlined } from '@ant-design/icons';

export interface ReadProcessProps {
  process: number;
}

export default function ReadProcess({ process = 0 }: ReadProcessProps) {
  const endX = useMemo(() => {
    return 6 + 3 * Math.sin(process * 2 * Math.PI);
  }, [process]);

  const endY = useMemo(() => {
    return 6 - 3 * Math.cos(process * 2 * Math.PI);
  }, [process]);

  const bigAngle = useMemo(() => {
    return +(process > 0.5);
  }, [process]);

  return process >= 1 ? (
    <CheckCircleOutlined style={{ color: 'var(--color-success)' }} />
  ) : (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="6"
        cy="6"
        r="4.58333"
        stroke={process === 0 ? '#A3A3A3' : '#00B600'}
        strokeWidth="0.833333"
      />
      <path d={`M6,6 L6,3 A3,3 0 ${bigAngle} 1 ${endX},${endY}`} fill="#00B600" />
    </svg>
  );
}
